<template>
  <label>
    <input
      :id="id"
      type="checkbox"
      data-testid="checkbox"
      :disabled="disabled"
      :checked="value"
      :name="name"
      :required="required"
      @change="$emit('input', $event.target.checked)"
    />
    <span class="wrn-checkbox-container__checkbox" />
    <slot />
  </label>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Checkbox extends Vue {
  /** Value informing that checkbox is either checked or not */
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop({ type: Boolean, default: false }) private value!: boolean;
  @Prop({ type: String, required: false }) private name?: string;
  @Prop({ type: Boolean, default: false }) private required!: boolean;
  @Prop({ type: String, required: false }) private id?: string;
}
</script>

<style lang="less" scoped>
label {
  display: flex !important;
  align-items: center;
}

.wrn-checkbox {
  color: @text-primary!important;
  background-color: @background-primary!important;
}

.wrn-checkbox:hover {
  background-color: @background-hover!important;
}

input[type='checkbox'] {
  display: none;
  align-items: center;

  &:focus + .wrn-checkbox-container__checkbox::before {
    border: 1px solid @element-primary;
  }
}
</style>
